import { getApps, getApp, initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";

const firebaseConfig = {
  apiKey: "AIzaSyCvNBar-yCqvrIWsLNaYnks8binEKiqFv8",
  authDomain: "codecrest-f725d.firebaseapp.com",
  projectId: "codecrest-f725d",
  storageBucket: "codecrest-f725d.appspot.com",
  messagingSenderId: "108759174451",
  appId: "1:108759174451:web:639eb8b4996ed682bac246",
};
// const firebaseConfig = {
//   apiKey: process.env.REACT_APP_API_KEY,
//   authDomain: process.env.REACT_APP_AUTHDOMAIN,
//   projectId: process.env.REACT_APP_PROJECTID,
//   storageBucket: process.env.REACT_APP_STORAGEBUCKET,
//   messagingSenderId: process.env.REACT_APP_MESSAGESENDERID,
//   appId: process.env.REACT_APP_APPID,
// };

const app = getApps.length > 0 ? getApp() : initializeApp(firebaseConfig);
const auth = getAuth(app);
const db = getFirestore(app);
export { app, auth, db };
